import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Icomoon__tag",
  "use": "Icomoon__tag-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"Icomoon__tag\"><path d=\"M30.5 0h-12c-.825 0-1.977.477-2.561 1.061L1.06 15.94a1.505 1.505 0 0 0 0 2.121L13.939 30.94a1.505 1.505 0 0 0 2.121 0l14.879-14.879C31.522 15.478 32 14.325 32 13.5v-12c0-.825-.675-1.5-1.5-1.5zM23 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol